<template>
    <div>
      <!--    表格部分-->
      <el-table :data="tableData" style="width: 100%"  v-loading="loading" border id="tableDataId" size="mini">
        <el-table-column header-align="center" align="center" prop="id" label="序号" sortable>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="account" label="代付账户">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="dealer_id" label="账户ID">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="account_name" label="账户名称">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="total_balance" label="账户余额">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="date_time" label="更新时间">
        </el-table-column>
      </el-table>
    </div>
  </template>
  <script>
  export default {
    name: "payAccount",
    components: {
    //   prints
    },
    data() {
      return {
        // 主页面部分
        loading: true, //列表loadding
        tableData: [], //表格数据
      }
    },
    created() {
      this.getData()
    },
    methods: {
      getData() { //初始化数据
        this.loading = true;
        this.$api.post("/api/system/getYunAccounts", {}, res => {
          if (res.status == 200) {
              let data = res.data;   
              this.tableData = [
                {
                    id:1,
                    account:"云账户",
                    dealer_id:data.dealer_id,
                    account_name:"河北通点",
                    total_balance:data.total_balance,
                    date_time:data.date_time,
                }
              ]
          } else {
            this.$message.error(res.msg);
          }
          //渲染结束后取消加载
          this.loading = false;
        })
      },
    
    }
  }
  </script>
  
  <style scoped>
  /deep/ .el-form-item__content .el-input-group {
    vertical-align: middle !important;
  }
  
  .code {
    cursor: pointer;
  }
  
  .code:hover {
    color: blue;
    text-decoration: underline;
  }
  </style>
  
  